module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edmodo-header"
  }, [_c('header', {
    staticClass: "wrap clearfix"
  }, [_c('h1', {
    staticClass: "title fl"
  }, [(_vm.isShowBack) ? _c('div', {
    staticClass: "header-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/main"
    }
  }, [_c('img', {
    staticClass: "edmodo-logo",
    attrs: {
      "src": _vm.logo,
      "alt": "EdmodoLabs"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right fr clearfix"
  }, [_c('header-search'), _vm._v(" "), (!_vm.isLogin) ? _c('a', {
    staticClass: "log login",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('txt_0002')))]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('span', {
    staticClass: "signup user"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.userLogo),
      expression: "userLogo"
    }],
    staticClass: "img-per-after fl",
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "user-name fl",
    attrs: {
      "title": _vm.user_name
    }
  }, [_vm._v(_vm._s(_vm.user_name))])]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de8db8ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edmodo/header.vue
// module id = 469
// module chunks = 9